/* =====================================================================

  This is a configuration file for feature Flags
  Import them like this:

  import { FEATURE_SHOW_DEVELOPER_TOOLBAR } from '@/features.js';

======================================================================== */

/* ================================= Beta ================================= */

export const IS_CLOSED_BETA = true;

/* ============================ Loading related ============================= */

export const ENABLE_PERSISTENT_REGISTRY = false;

export const LOAD_TRELLO_ON_STARTUP = false;

export const LOAD_GOOGLE_ON_STARTUP = true;

export const LOAD_QUOTES_ON_STARTUP = false;

export const LOAD_LEGACY_PROJECT_ON_STARTUP = false;

export const LOAD_GOALS_ON_STARTUP = true;

export const LOAD_CHALLENGES_ON_STARTUP = false;

/* =============================== Misc ================================ */

/**
 * Enable / Disable color mixing for colored goals while highlightened
 *  (mouse over, selected)
 */
export const FEATURE_MIX_COLOR = true;

/* Change beheviour when a select is triggered during drag */
// 0 = off, 1 = onDragStart, 2 = onDragEnd
export const FEATURE_TRIGGER_SELECT = 2;

/** Show additional developer buttons in top bar */
export const FEATURE_SHOW_DEVELOPER_TOOLBAR = ( process.env.NODE_ENV !== 'production' );

/* Enable list view */
export const FEATURE_PROJECT_LIST_VIEW = true;

/* Enable project timeline aka. MilestonePlanner */
export const FEATURE_PROJECT_TIMELINE = true;

/* Enable laser for users (not implemented) */
export const FEATURE_USER_ACTIVITY_LASER = true;

export const ENABLE_VUE_ANALYTICS = false;

export const DISABLE_SENRTY = true;

export const USE_CALENDARWEEK_BATCHES = false;

export const ENABLE_BYPASS_SYNC = false;

export const SIMULATE_SLOW_LOAD = false;

export const ENABLE_PRE_RENDERED_POPOVERS = false; /* Feature can be removed after testing */

export const ENABLE_POPOVERS_FOR_SOURCE = ['TSC', 'USER', 'OPTIMIZER', 'OPTIMIZER-LOCKED'];

export const ENABLE_AUTOMATIC_LAYOUT_CHANGE = true;

/* Task heights in the kanban board are proportional to their duration */
export const ENABLE_PROPORTIONAL_TASK_HEIGHTS = true;

/* Enables improved sidebar menu based on vue-sidebar-menu */
export const ENABLE_VUE_SIDEBAR_MENU = true;

export const FEATURE_BUG_BOUNTY = true;

export const FEATURE_ENABLE_SEARCH = false;

/* =============================== Optimizer ================================ */

/* Enables the local optimizer. Run optimization in webworker. */
export const OPTIMIZER_RUNS_LOCALLY = true;

export const ENABLE_OPTIMIZER_DEBUG_SIDEBAR = false //( process.env.NODE_ENV !== 'production' );

export const TRIGGER_OPTIMIZER_ON_INPUT_CHANGE = true;

/* This enables a very aggresive triggering strategy on every change of the registry state
   (basically every database update) */
export const TRIGGER_OPTIMIZER_ON_REGISTRY_CHANGE = false;

export const OPTIMIZER_TRIGGER_DEBOUNCE_TIME = 0;

/* =============================== Visionboard ============================== */

export const ENABLE_VISIONBOARD = false;

export const DISABLE_VISIONBOARD_PREVIEW = true;

export const FEATURE_SHOW_CLOCK = true;

export const FEATURE_SHOW_QUOTE_OF_THE_DAY = true;

export const ENABLE_VISIONBOARD_WHEEL_ZOOM = true;

/* =============================== Dayplanner ============================== */

export const ENABLE_AUTO_HIDE_BACKLOG = true;

/* =============================== Bugtracker =============================== */

function get_bugtracker_target_ids() {
  if ( !process.browser ) {
    return null
  }
  switch ( process.env.VUE_APP_DEPLOY_TARGET ) {
    case 'goalpilot-dev-rc1': return {
      uid:    'TEAM',
      goalId: '-Lbx6bJQejiG64M27tAY',
      taskId: '-Lf78cOkvWxRoUmjgKN0'
    };
    case 'goalpilot-beta': return {
      uid:    'TEAM',
      goalId: '-LcagDx1ovaCxd8EnzXP',
      taskId: '-LcbBYtceydXlUFgZgyh'
    };
    default: console.error("No Bugtracker defined");
  }
}

export const BUGTRACKER_TARGET_TASK_IDS = get_bugtracker_target_ids();
